import { useCallback, useEffect, useState } from 'react';
import ChartSegment from './ChartSegment';
import TableSegment from './TableSegment';
import styles from './MoodboardElementaryMobile.module.scss';

interface Props {
  currentData: any;
  barChartData: any;
  dataGenerated: boolean;
  isHideNames: boolean;
  onClickStudentName: (entry: any) => void;
  tableData: any;
  showPreviousWeekNav: boolean;
  showNextWeekNav: boolean;
  shiftWeekPrevious: () => void;
  shiftWeekNext: () => void;
}

const MoodboardElementaryMobile = ({
  currentData,
  barChartData,
  dataGenerated,
  isHideNames,
  onClickStudentName,
  tableData,
  showPreviousWeekNav,
  showNextWeekNav,
  shiftWeekPrevious,
  shiftWeekNext,
}: Props): JSX.Element => {
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const [anchorDate, setAnchorDate] = useState(today);
  const [dateSpan, setDateSpan] = useState<Date[] | []>([]);

  const apiConfig = {
    to: [
      { transform: 'translate3d(-100%, 0, 0)', opacity: 0 },
      { transform: 'translate3d(100%, 0, 0)', opacity: 0 },
      { transform: 'translate3d(0%, 0, 0)', opacity: 1 },
    ],
  };

  const getDateSpan = useCallback((date: Date) => {
    const dateArray = Array(7)
      .fill(new Date(date))
      .map((el, i) => new Date(el.setDate(el.getDate() - el.getDay() + i)));
    setDateSpan(dateArray);
  }, []);

  // change the date span for the chart
  const goToPreviousDateSetForChart = () => {
    shiftWeekPrevious();
    const newAnchorDate = new Date(dateSpan[0].setDate(dateSpan[0].getDate() - 7));
    setAnchorDate(newAnchorDate);
  };

  const goToNextDateSetforChart = () => {
    shiftWeekNext();
    const newAnchorDate = new Date(dateSpan[0].setDate(dateSpan[0].getDate() + 7));
    setAnchorDate(newAnchorDate);
  };

  // change the date for the table
  const goToPreviousDateForTable = () => {
    const newDate = new Date(anchorDate.setDate(anchorDate.getDate() - 1));
    setAnchorDate(newDate);
    if (newDate < dateSpan[0]) {
      shiftWeekPrevious();
    }
  };

  const goToNextDateForTable = () => {
    const newDate = new Date(anchorDate.setDate(anchorDate.getDate() + 1));
    setAnchorDate(newDate);
    if (newDate > dateSpan[6]) {
      shiftWeekNext();
    }
  };

  useEffect(() => {
    getDateSpan(anchorDate);
  }, [getDateSpan, anchorDate]);

  return (
    <section className={styles.moodboardElementaryMobileSection}>
      {dataGenerated && tableData ? (
        <>
          <ChartSegment
            apiConfig={apiConfig}
            barChartData={barChartData}
            currentSelectedDay={anchorDate}
            dateSpan={dateSpan}
            goToNextDateSet={goToNextDateSetforChart}
            goToPreviousDateSet={goToPreviousDateSetForChart}
            showNextWeekNav={showNextWeekNav}
            showPreviousWeekNav={showPreviousWeekNav}
          />
          <TableSegment
            apiConfig={apiConfig}
            currentDate={anchorDate}
            dataGenerated={dataGenerated}
            goToNextDate={goToNextDateForTable}
            goToPreviousDate={goToPreviousDateForTable}
            isHideNames={isHideNames}
            onClickStudentName={(entry) => onClickStudentName(entry)}
            tableData={tableData}
            showNextDateNav={anchorDate < today}
            showPreviousDateNav={anchorDate >= new Date(currentData[0].weekRange[0])}
          />
        </>
      ) : (
        <div className={styles.noDataContainer}>There is no data to display.</div>
      )}
    </section>
  );
};

export default MoodboardElementaryMobile;
